export const routerMetabase = [
  {
    path: 'laporan/metabase/:id',
    meta: { title: 'metabase' },
    component: () => import('@/views/metabase/index.vue'),
  },
]
